import { Button, Flex, Link } from "@chakra-ui/react"
import { createFileRoute } from "@tanstack/react-router"
import NotFound from "../../components/Common/NotFound"

const PRIVACYBEE_ID = import.meta.env.VITE_PRIVACYBEE_ID

export const Route = createFileRoute("/_layout/datenschutz")({
  component: PrivacyPolicy,
  notFoundComponent: NotFound,
})

function PrivacyPolicy() {
    return (
        <Flex direction="column" w="full" alignItems="start" px={5}>
            <Button variant="primary" asChild>
                <Link href="#" className="privacybee-display-preferences">Cookie Einstellungen</Link>
            </Button>
            
            <privacybee-widget website-id={PRIVACYBEE_ID} type="dsg" lang="de" style={{ width: "100%" }}></privacybee-widget>
        </Flex>
    )
}
